'use client'
import { ComponentProps, useEffect, useState } from "react"
import { twMerge } from "tailwind-merge"

interface textInputUpperCaseProps extends Omit<ComponentProps<'input'>, 'onChange'> {
    onChange?: (value: string) => void
    value?: string
}

export function TextInputUpperCase({ value = '', onChange, ...props }: textInputUpperCaseProps) {
    const [formattedValue, setFormattedValue] = useState('')

    useEffect(() => {
        const clean = value.replace(/[^A-Za-z0-9]/g, '')
        setFormattedValue(clean.toUpperCase())
    }, [value])

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value
        const clean = inputValue.replace(/[^A-Za-z0-9]/g, '')
        const upperValue = clean.toUpperCase()

        setFormattedValue(upperValue)

        if (onChange) {
            onChange(upperValue)
        }
    }


    return (
        <input {...props}
            className={twMerge(`
                py-2 px-3 outline-hidden appearance-none 
                rounded-sm shadow border border-dark_secondary dark:border-light_secondary
                dark:bg-silver-500 focus:ring-ochre_accent focus:border-ochre_accent`,
                props.className)}
            value={formattedValue}
            onChange={handleInputChange}
        />
    )
}